import { useAtom } from 'jotai';

import { zodToJsonSchema } from 'zod-to-json-schema';

import { widgetParamsAtom } from '../storage';
import { LoadWidgetPropsSchema } from '@automation-suite/widget-client/lib/package';
import Editor from '@monaco-editor/react';

import { useCallback, useState } from 'react';

import { Action } from '@soluto-private/mx-asurion-ui-react';

import { editorValueAtom } from '../storage/editorValueAtom';
import styled from 'styled-components';

const jsonSchema = zodToJsonSchema(LoadWidgetPropsSchema, {
  removeAdditionalStrategy: 'strict',
});

const ActionButtonContainer = styled.div``;

export const OptionEditor = () => {
  const [valid, setValid] = useState<boolean>(true);
  const [, setWidgetParams] = useAtom(widgetParamsAtom);
  const [value, setValue] = useAtom(editorValueAtom);

  const handleSubmit = useCallback(() => {
    if (value) {
      const parsedValue = JSON.parse(value);
      setWidgetParams(parsedValue);
    }
  }, [setWidgetParams, value]);

  return (
    <>
      <Editor
        defaultLanguage="json"
        height="300px"
        onChange={setValue}
        onValidate={(markers) => (markers.length === 0 ? setValid(true) : setValid(false))}
        options={{
          formatOnPaste: true,
          formatOnType: false,
          minimap: { enabled: false },
          wordWrap: 'on',
          wrappingIndent: 'same',
        }}
        value={value}
        onMount={(_editor, monaco) =>
          monaco?.languages.json.jsonDefaults.setDiagnosticsOptions({
            schemas: [
              {
                fileMatch: ['*'],
                schema: jsonSchema,
                uri: 'https://json-schema.org/draft/2020-12/schema',
              },
            ],
            validate: true,
          })
        }
      />
      <ActionButtonContainer>
        <Action onClick={handleSubmit} state={valid ? 'enabled' : 'disabled'}>
          Preview
        </Action>
      </ActionButtonContainer>
    </>
  );
};
